import { strLang } from "../../functions/strLang";
import { checkTime } from "../../functions/checkTime";
import { checkDate } from "../../functions/checkDate";
import MessageIcon from "@mui/icons-material/Message";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import FlagIcon from "@mui/icons-material/Flag";
import imagePin from "../../images/pin.png";
import { emptys } from "../../data/main";
import { colorsList } from "../../data/colorsList";
export default function TerData({ data, list, onClick, terGroups }) {
  const {
    ID = "",
    NOM = "",
    HECHOS = 0,
    EVENTS,
    TOTAL = 0,
    FLAGS,
    NP,
    NOTES,
    DATE,
    TERGROUP,
    DESCRIP,
    TILE,
  } = data || {};
  return (
    <div
      onClick={() => {
        onClick(ID, NOM, DESCRIP);
      }}
      style={{
        marginTop: 5,
        marginBottom: 5,
      }}
    >
      {typeof list === "number" && (
        <div>
          {strLang("territories")}: {list}
        </div>
      )}
      {!list && (
        <>
          {TILE !== "default" && !emptys.includes(TILE) && (
            <div style={{ fontSize: 15 }}>
              <b>{`${strLang("map")}: ${strLang(TILE, "tileNames")}`}</b>
            </div>
          )}
          <div>
            {`${strLang("status")}: ${strLang(
              !HECHOS
                ? "readyToStart"
                : HECHOS === TOTAL
                ? "finalized"
                : "inProgress"
            ).toLowerCase()}`}
          </div>
        </>
      )}
      <div>
        {`${strLang("addresses")}: ${HECHOS > 0 ? HECHOS + " / " : ""}${TOTAL}`}
        <span style={{ position: "relative" }}>
          <div
            style={{
              position: "absolute",
              left: 5,
              top: -5,
              display: "flex",
              gap: 5,
              flexDirection: "row",
            }}
          >
            {FLAGS > 0 && (
              <FlagIcon style={{ color: colorsList.red, fontSize: 20 }} />
            )}
            {NP > 0 && <img src={imagePin} alt="pin" style={{ height: 20 }} />}
            {NOTES > 0 && (
              <MessageIcon style={{ color: colorsList.red, fontSize: 20 }} />
            )}
            {EVENTS && (
              <ReportProblemIcon
                style={{ color: colorsList.orange, fontSize: 20 }}
              />
            )}
          </div>
        </span>
      </div>
      {DATE && (
        <>
          <div>
            {strLang("date")}: {checkDate(DATE)}
          </div>
          <div>
            {strLang("time")}: {checkTime(DATE)}
          </div>
        </>
      )}
      {TERGROUP && (
        <div>
          {strLang("group")}:{" "}
          {terGroups.filter((e) => e.code === TERGROUP)[0]?.name ?? ""}
        </div>
      )}
    </div>
  );
}
